import type { AccountSummary, ProjectStats } from '@/lib/api/client'

interface PortfolioSummaryProps {
  summary: AccountSummary | null
  stats: Record<string, ProjectStats>
}

function countByPhase(stats: Record<string, ProjectStats>) {
  const buckets = { discovery: 0, validation: 0, build: 0 }
  for (const s of Object.values(stats)) {
    if (!s.currentPhaseId) continue
    const id = s.currentPhaseId.toLowerCase()
    if (id === 'problem' || id === 'discover') buckets.discovery++
    else if (id === 'validate' || id === 'solution') buckets.validation++
    else if (id === 'define' || id === 'build' || id === 'product' || id === 'market') buckets.build++
  }
  return buckets
}

export function PortfolioSummary({ summary, stats }: PortfolioSummaryProps) {
  if (!summary) return null
  const phases = countByPhase(stats)

  const cells: Array<{ value: string | number; label: string; accent?: boolean }> = [
    { value: summary.total, label: 'Projects' },
    { value: phases.discovery, label: 'In discovery', accent: phases.discovery > 0 },
    { value: phases.validation, label: 'In validation' },
    { value: phases.build, label: 'In build' },
    { value: summary.totalPersonas, label: 'Personas' },
    { value: summary.totalDocuments, label: 'Documents' },
  ]

  return (
    <div className="flex border-y border-border-subtle">
      {cells.map((cell, i) => (
        <div
          key={cell.label}
          className={`flex-1 px-5 py-4 ${i < cells.length - 1 ? 'border-r border-border-subtle' : ''}`}
        >
          <div
            className={`font-display font-semibold text-[22px] leading-none tracking-tight tabular-nums ${
              cell.accent ? 'text-accent-500' : 'text-text'
            }`}
          >
            {cell.value}
          </div>
          <div className="mt-1.5 text-[11px] uppercase tracking-wider text-text-muted">
            {cell.label}
          </div>
        </div>
      ))}
    </div>
  )
}
